import { Injectable, NgZone, signal } from '@angular/core';
import { Router } from '@angular/router';
import { WorkspaceTabs } from '@pages/workspace/workspace.component';
import { UrlService } from '@services/url.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private router: Router,
    private zone: NgZone,
    private urlService: UrlService,
  ) {}
  public userDetailsRouteActive = signal<boolean>(false);

  public navigateToAdminConnectors(queryParams: {} = {}): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getWorkspacePageURL()], {
        queryParams,
      });
    });
  }

  public navigateToSearchResult(id: string): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getSearchResultsPageURL(id)]);
    });
  }

  public navigateToLogin(queryParams: {} = {}): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getLoginPageURL()], {
        queryParams,
      });
    });
  }

  public navigateToSearchHome(queryParams: {} = {}): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getSearchHomePageURL()], {
        queryParams,
      });
    });
  }

  public navigateToProfile(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getProfilePageURL()]);
    });
  }

  public navigateToSubscription(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getBillingPageURL()]);
    });
  }
  public navigateToPricingPlans(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getPricingPlansPageURL()]);
    });
  }

  public navigateToSubscriptionDetails(itemId: string): void {
    this.zone.run(() => {
      this.router.navigate(['/dashboard/home', { outlets: { dashboard: ['subscription-item-details', itemId] } }]);
    });
  }

  public navigateNotFound(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getNotFoundPageURL()]);
    });
  }
  public navigateTimeOut(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getTimeoutPageURL()]);
    });
  }

  public navigateForbidden(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getForbiddenPageURL()]);
    });
  }

  public navigateToInternalServerError(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getInternalServerErrorPageURL()]);
    });
  }

  public navigateToBadRequest(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getBadRequestPageURL()]);
    });
  }

  public navigateToOnboardingStepOne(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getOnboardingStepOnePageURL()]);
    });
  }

  public navigateToOnboardingStepTwo(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getOnboardingStepTwoPageURL()]);
    });
  }

  public navigateToOnboardingStepThree(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getOnboardingStepThreePageURL()]);
    });
  }

  public navigateToOnboardingStepFour(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getOnboardingStepFourPageURL()]);
    });
  }

  public navigateToOnboardingStepFive(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getOnboardingStepFivePageURL()]);
    });
  }

  public navigateToSpaces(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getSpacesPageURL()]);
    });
  }

  public navigateToSpaceDetails(id: string): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getSpacesDetailsPageURL(id)]);
    });
  }

  public navigateToMyConnectors(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getConnectorsPageURL()]);
    });
  }

  public navigateToUserDetails(id: string): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getManageUsersPageURL(id)]);
    });
  }

  public navigateToWorkspace(selectedTab?: WorkspaceTabs): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getWorkspacePageURL()], {
        queryParams: { selectedTab },
      });
    });
  }

  public navigateToAgents(): void {
    this.zone.run(() => {
      this.router.navigate([this.urlService.getAgentsPageURL()]);
    });
  }
}
